/* @flow */

const backgroundColorRegex = /background-color:(.+);/;

export const removeBackgroundColor = function(htmlString: string): string {
  return htmlString.replace(backgroundColorRegex, '');
};

export const getBackgroundColor = function(htmlString: string): string {
  const colorHex = htmlString.match(backgroundColorRegex);
  return colorHex ? colorHex[1] : '#ed4b4b';
};


